import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SliderMenuItem } from '../../typing';
import { NzIconService } from 'ng-zorro-antd/icon';
import * as IconSvgs from '../../icons/iconSvgs';

@Component({
  selector: 'bcsc-digi-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnChanges {

  @Input() isCollapsed = false;

  @Input() menuItems: SliderMenuItem[] = [];
  @Input() selectItem = '';
  @Output() onMenuClick = new EventEmitter();


  constructor(
    private nzIconService:NzIconService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const sliderMenuItems = changes['menuItems'];
    if (sliderMenuItems && sliderMenuItems.currentValue) {
      sliderMenuItems.currentValue.forEach((item: SliderMenuItem) => { 
        item?.icon && this.initIcon(item.icon);
        if (item?.items) {
          item.items.forEach(child => {
            child?.icon && this.initIcon(child.icon);
          });
        }
      })
    }
  }

  initIcon(type: string) {
    const iconSvgs: { [props: string]: string } = IconSvgs;
      const iconType: string = type.replace(/-/g, '').toUpperCase();
      this.nzIconService.addIconLiteral(`ng-zorro:${type}`, iconSvgs[iconType]);
  }
}
